import { styled } from '@mui/system';
import TextField from '@mui/material/TextField';
import { DARK_TRANSPARENT_WHITE, PRIMARY_COLOR, RED_COLOR } from '../../../utils/color-const';
import { ONE_MINUS_GOLDEN_RATIO, ONE_MINUS_GOLDEN_RATIO_EM } from '../../../utils/style-const';

export const CommonInput = styled(TextField)(({ theme, noWidthLimit, inline, small, medium }) => ({
  ...(noWidthLimit ? {} : { maxWidth: '600px' }),
  width: '100%',
  input: {
    ...(inline && { width: '100%' }),
    ...(small && { width: '100px' }),
    ...(medium && { width: '280px' }),
    ...(!inline && !small && !medium && { width: '100%' }),
    '&:-webkit-autofill': {
      transition: 'background-color 5000s ease-in-out 0s',
    },
  },
}));

export const CommonInlineInputDiv = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'inline-flex',
  [theme.breakpoints.down('sm')]: {
    display: 'block',
  },
}));

export const CommonInputWrapper = styled('div')({
  padding: ONE_MINUS_GOLDEN_RATIO_EM,
  display: 'flex',
  justifyContent: 'center',
});

export const FormImageContainer = styled('div')({
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  '> img': {
    maxWidth: '200px',
    maxHeight: '140px',
  },
});

export const InfoContainer = styled('div')({
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  width: '100%',
  height: '100%',
});

export const FormButtonBar = styled('div')({
  display: 'inline-flex',
  alignItems: 'center',
  pointerEvents: 'none',
  position: 'absolute',
  padding: `0 ${ONE_MINUS_GOLDEN_RATIO}em`,
  top: '16px',
  right: '4px',
  left: 0,
});

export const FormButtonWrapper = styled('div')({
  pointerEvents: 'all',
  backgroundColor: DARK_TRANSPARENT_WHITE,
  borderRadius: '50% 50%',
});
